// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__2Or8M","pulse-animation":"logo_pulse-animation__3mQe2"};